export enum Recipientgroup {
  Staff = 'Staff',
  Participants = 'Participants',
  All = 'All'
}
